var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "site-footer-back" }, [
    _vm.$currentUserRoles.includes("manager") ||
    _vm.$currentUserRoles.includes("managerAssist")
      ? _c(
          "div",
          [
            _c("HistoryNotifications", {
              staticClass: "flowHistoryButton shadow-sm",
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }